/* Native country dialog, with the existing explicit-choice cookie and country suggestion. */
(() => {
  if (customElements.get('park-country-panel')) return;
  customElements.define('park-country-panel', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.host = this.closest('[data-park-country-host]');
      this.dialog = this.querySelector('dialog');
      this.events = new AbortController();
      const on = (element, name, handler, capture = false) => element.addEventListener(name, handler, { capture, signal: this.events.signal });
      on(document, 'click', event => {
        const trigger = event.target.closest('[data-country-open]');
        if (!trigger) return;
        event.preventDefault();
        this.opener = trigger;
        this.toggle(true);
      });
      on(this.querySelector('[data-country-close]'), 'click', () => this.toggle(false));
      on(this.dialog, 'cancel', event => { event.preventDefault(); this.toggle(false); });
      on(this.dialog, 'click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.toggle(false);
      });
      on(this.dialog, 'keydown', event => {
        if (event.key !== 'Tab') return;
        const controls = [...this.dialog.querySelectorAll('button,a[href]')];
        const first = controls[0], last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
      on(this, 'click', event => {
        const link = event.target.closest('[data-country-link]');
        if (!link) return;
        // Keep the existing explicit-choice cookie and destination marker.
        this.setGeoCookie();
        const url = new URL(link.href);
        url.searchParams.set('edition-geoswtich', '');
        link.href = url.href;
      });
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.host, { attributes:true, attributeFilter:['class'] });
      this.sync();
      on(document, 'geolocator:toggle', () => this.toggle(!this.dialog.open));
      on(document, 'geolocator:getLocation', () => this.suggestCountry());
      if (new URL(location.href).searchParams.has('edition-geoswtich')) this.setGeoCookie();
      if (!window.Shopify?.designMode) this.suggestCountry();
    }
    setGeoCookie() {
      const days = Math.max(1, Number(this.host.dataset.cookieduration) || 30);
      const expires = new Date(Date.now() + days * 86400000).toUTCString();
      document.cookie = `editiongeolocation=countrychanged; expires=${expires}; path=/`;
    }
    async suggestCountry() {
      if (this.suggestionDismissed()) return;
      if (document.cookie.split(';').some(part => part.trim().startsWith('editiongeolocation='))) return;
      this.request?.abort();
      const controller = this.request = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 8000);
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}browsing_context_suggestions.json`, {signal: controller.signal});
        if (!response.ok) return;
        const data = await response.json();
        const country = data.detected_values?.country?.handle;
        if (!controller.signal.aborted && !this.suggestionDismissed() && this.isConnected && country && country !== this.host.dataset.activecountryhandle) this.toggle(true);
      } catch (_) { /* Manual country selection remains available. */ }
      finally { clearTimeout(timeout); if (this.request === controller) this.request = null; }
    }
    suggestionDismissed() {
      try { return this.dismissed || window.sessionStorage.getItem('park-country-dismissed') === 'true'; }
      catch (_) { return this.dismissed; }
    }
    toggle(open) {
      if (!open && this.dialog.open) {
        // Closing keeps the current country; it is not an explicit country choice.
        this.dismissed = true;
        try { window.sessionStorage.setItem('park-country-dismissed', 'true'); }
        catch (_) { /* Keep the in-page dismissal when storage is unavailable. */ }
        this.request?.abort();
      }
      if (open === !this.host.classList.contains('tw-hidden')) return;
      this.host.classList.toggle('tw-hidden', !open);
      document.body.classList.toggle('tw-overflow-hidden', open);
      this.sync();
    }
    sync() {
      const open = !this.host.classList.contains('tw-hidden');
      if (open && !this.dialog.open) {
        this.opener ||= document.activeElement;
        this.dialog.showModal();
        this.querySelector('[data-country-close]').focus({preventScroll:true});
      } else if (!open && this.dialog.open) {
        this.dialog.close();
        this.opener?.focus?.({preventScroll:true});
        this.opener = null;
      }
      document.querySelectorAll('[data-country-open]').forEach(button => button.setAttribute('aria-expanded', String(open)));
      const selected = this.querySelector('[aria-current]');
      if (selected) document.querySelectorAll('[data-country-current]').forEach(label => { label.textContent = selected.dataset.countryLabel; });
    }
    disconnectedCallback() { this.observer?.disconnect(); this.events?.abort(); this.events = null; this.request?.abort(); if (this.dialog?.open) { this.dialog.close(); document.body.classList.remove('tw-overflow-hidden'); } }
  });
})();
